import React from 'react'
import SearchForm from "../../shared/components/searchForm/SearchForm"
import { billingPageSearchFields } from '../utils/searchField';
import { appModules } from '../../roles/components/UserHasPermission';
import { Grid } from '@material-ui/core';
import ArrowDropDownCircleOutlinedIcon from '@material-ui/icons/ArrowDropDownCircleOutlined';
import GraphsForBillingPage from './GraphsForBillingPage';


const BillingPage = ({
    searchFieldsValues,
    hideAddButton,
    handleSearchFieldChange,
    handleSearchSubmit,
    handleSearchClear,
    hideUniversalSearch,
    showAllData,
    toggleData,
    billingReportData,
    total,
    active,
    inactive,
    disconnected,
    companyList,
    billingList,
    floorList,
    totalgrapghActiveCount,
    totalgrapghInactiveCount,
    totalgrapghDisconnectedCount
}) => {
 /*    console.log("searchFieldsValues at BillingPage", searchFieldsValues)
    console.log("data at changing graph,totalgrapghActiveCount", totalgrapghActiveCount) */
    const classNames = "billingReport-list-item-header billingReport-list-item-header-bg";
    const classNamesBorder = "billingReport-list-item-header billingReport-list-item-header-bg billingReport-list-item-header-border"
    const gridupper = {paddingBottom: "10px", fontSize: "1.25rem", lineHeight: "19px", height: "40px"} 
    const gridLower = {alignSelf: "center", fontSize: "25px", lineHeight: "50px"}
    return (<>
        <div className="page_background">
            <SearchForm
                content={billingPageSearchFields(searchFieldsValues, companyList, billingList, floorList)}
                hideAddButton={hideAddButton}
                handleFieldChange={handleSearchFieldChange}
                handleSubmit={handleSearchSubmit}
                handleClear={handleSearchClear}
                hideUniversalSearch={hideUniversalSearch}
                appModule={appModules.BILLING_REPORT}

            />
        </div>
        <div >

        <Grid container justifyContent='space-between' className="gridSpacing">
                        <Grid item xs={2} container direction='column' className={classNames} style={{border:"2px solid white", backgroundColor:"#fff",  boxShadow: "0 2px 6px 0 rgba(0, 0, 0, 0.11)" }}>
                            <Grid item style={gridupper}>Building | Floor Activity</Grid>
                            <Grid item style={{ alignSelf: "center", fontSize: "25px", lineHeight: "50px" }} >Average</Grid>
                        </Grid>
{/*                         <Grid item xs={2} container direction='column' className="billingReport-list-item-header">
                            <Grid item style={{ paddingBottom: "10px", fontSize: "1.25rem", lineHeight: "19px", height: "40px" }}>Total Rooms</Grid>
                            <Grid item style={{ alignSelf: "center", fontSize: "25px", lineHeight: "50px" }}>{total}</Grid>
                        </Grid> */}
                        <Grid xs={2} item container direction='column' className={classNames} style={{border:"2px solid rgb(148, 206, 84)"}}>
                            <Grid item style={gridupper}>Active Rooms</Grid>
                            <Grid item style={gridLower}>{totalgrapghActiveCount}</Grid>
                        </Grid>
                        <Grid xs={2} item container direction='column' className={classNames} style={{border:"2px solid rgb(175, 198, 225)"}}>
                            <Grid item style={gridupper}>Inactive Rooms</Grid>
                            <Grid item style={gridLower}>{totalgrapghInactiveCount}</Grid>
                        </Grid>
                        <Grid xs={2} item container direction='column' className={classNames} style={{border:"2px solid rgb(209, 118, 129)"}}>
                            <Grid item style={gridupper}>Disconnected Rooms</Grid>
                            <Grid item style={gridLower}>{totalgrapghDisconnectedCount}</Grid>
                        </Grid>
                        <Grid xs={2} item container direction='column' className="billingReport-list-item-header" >
                            <Grid item style={gridupper}></Grid>
                            <Grid item style={gridLower}></Grid>
                        </Grid>
                      
                        <Grid xs={1} item container direction='column' alignContent='flex-end'>
                            <Grid item >
                               {/*  <img src="../img/down-arrow.png" style={{ cursor: 'pointer' }} onClick={toggleData} /> */}
                            </Grid>
                        </Grid>

                    </Grid>
         
                    <Grid container justifyContent='space-between' className="gridSpacing">
                        <Grid item xs={2} container direction='column' className={classNamesBorder} >
                            <Grid item style={gridupper}>Building | Floor</Grid>
                            <Grid item style={gridLower} >All</Grid>
                        </Grid>
                        <Grid item xs={2} container direction='column' className={classNamesBorder}>
                            <Grid item style={gridupper}>Total Rooms</Grid>
                            <Grid item style={gridLower}>{total}</Grid>
                        </Grid>
                        <Grid xs={2} item container direction='column' className={classNamesBorder}>
                            <Grid item style={gridupper}>Active Rooms</Grid>
                            <Grid item style={gridLower}>{active}</Grid>
                        </Grid>
                        <Grid xs={2} item container direction='column' className={classNamesBorder}>
                            <Grid item style={gridupper}>Inactive Rooms</Grid>
                            <Grid item style={gridLower}>{inactive}</Grid>
                        </Grid>
                        <Grid xs={2} item container direction='column' className={classNamesBorder}>
                            <Grid item style={gridupper}>Disconnected Rooms</Grid>
                            <Grid item style={gridLower}>{disconnected}</Grid>
                        </Grid>
                      
                        <Grid xs={1} item container direction='column' alignContent='flex-end'>
                            <Grid item >
                                <img src="../img/down-arrow.png" style={{ cursor: "pointer" }} onClick={toggleData} />
                            </Grid>
                        </Grid>

                    </Grid>
            
           




            {showAllData &&
                <Grid container>
                    <Grid item xs={12}>
                        {billingReportData.map((item) => {
                            return (<Grid flexDirection="row"  justifyContent='space-between' container className="gridSpacing">
                                <Grid item xs={2} className="billingReport-list-item">{item.buildingName + "|" + item.floorName}</Grid>
                                <Grid item xs={2} className="billingReport-list-item">{item.total} <span className="totalFont">Total</span></Grid>
                                <Grid item xs={2} className="billingReport-list-item">{item.active} <span className="totalFont">Total</span></Grid>
                                <Grid item xs={2} className="billingReport-list-item">{item.inactive} <span className="totalFont">Total</span></Grid>
                                <Grid item xs={2} className="billingReport-list-item">{item.disconnected} <span className="totalFont">Total</span></Grid>
                                <Grid item xs ={1}/>
                            </Grid>

                            )
                        })}

                    </Grid>
                </Grid>
            }

        </div>

    </>)
}
export default BillingPage